"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIsDown;

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _useMediaQueryTheme = _interopRequireDefault(require("@material-ui/core/useMediaQuery/useMediaQueryTheme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useIsDown(breakpoint) {
  return (0, _useMediaQueryTheme.default)((0, _useTheme.default)().breakpoints.down(breakpoint));
}